import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
const Counter = () => {
  const [startCount, setStartCount] = useState(false); // State to control animation
  const counterRef = useRef(null); // Ref for the section

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true); // Trigger the counter animation
        } else {
          setStartCount(false); // Reset if you want to stop/restart animation when it goes out
        }
      },
      {
        threshold: 0.5, // Adjust the threshold as needed
      }
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  return (
    <React.Fragment>
      
      
      <section className="py-5 bg-primary position-relative">
        <div className="bg-overlay bg-overlay-pattern opacity-50"></div>
        <Container>
          <Row className="align-items-center gy-4">
            <Col className="col-sm">
              <div>
                <h4 className="text-white mb-2">Ready to Get Started?</h4>
                {/* <p className="text-white-50 mb-0">
                  Create a new account
                </p> */}
              </div>
            </Col>
            <Col className="col-sm-auto">
              <div>
                <Link to="#!" className="btn bg-gradient btn-danger">
                  Create Free Account
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 position-relative bg-light" ref={counterRef}>
        <Container>
          <Row className="text-center gy-4">
            <Col lg={3} className="col-6">
              <div>
                <h2 className="mb-2">
                  <span className="counter-value" data-target="100">
                    {startCount && (
                      <CountUp start={0} end={100} duration={3} />
                    )}
                  </span>
                  +
                </h2>
                <div className="text-muted">Projects Completed</div>
              </div>
            </Col>

            <Col lg={3} className="col-6">
              <div>
                <h2 className="mb-2">
                  <span className="counter-value" data-target="24">
                    {startCount && (
                      <CountUp start={0} end={24} duration={3} />
                    )}
                  </span>
                </h2>
                <div className="text-muted">Win Awards</div>
              </div>
            </Col>

            <Col lg={3} className="col-6">
              <div>
                <h2 className="mb-2">
                  <span className="counter-value" data-target="20.3">
                    {startCount && (
                      <CountUp
                        start={0}
                        end={20.3}
                        duration={3}
                        decimals={1}
                      />
                    )}
                  </span>
                  k
                </h2>
                <div className="text-muted">Satisfied Clients</div>
              </div>
            </Col>

            <Col lg={3} className="col-6">
              <div>
                <h2 className="mb-2">
                  <span className="counter-value" data-target="50">
                    {startCount && (
                      <CountUp start={0} end={50} duration={3} />
                    )}
                  </span>
                </h2>
                <div className="text-muted">Employees</div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Counter;
